
import * as actionType from "../../../context/actions";
import GetProformaInvoiceDataLocal from "./GetProformaInvoiceDataLocal";

const DeleteProformaInvoiceDataInLocal = async (state, dispatch, uniqueID) => {

    try {

        // Retrieve existing invoices from localStorage
        let existingData = JSON.parse(localStorage.getItem("LOCAL_PROFORMA_INVOICES")) || [];

        // Find the index of the invoice with the matching invoiceId
        const indexToDelete = existingData.findIndex((invoice, index) => invoice.uniqueID === uniqueID || index === uniqueID || invoice.id === uniqueID);

        // Validate if the invoice exists
        if (indexToDelete === -1) {
            return { success: true, message: "Invoice deleted successfully!" };
        }

        // Remove the invoice at the found index
        existingData.splice(indexToDelete, 1);

        // Save updated data back to localStorage
        localStorage.setItem("LOCAL_PROFORMA_INVOICES", JSON.stringify(existingData));

        setTimeout(() => {
            dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
        }, 5000);

        // Refresh invoice data
        await GetProformaInvoiceDataLocal(state, dispatch);

        return { success: true, message: "Invoice deleted successfully!" };
    } catch (error) {
        return { success: false, message: error.message || error };
    }
};

export default DeleteProformaInvoiceDataInLocal;
